'use client';

import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitCheckboxBase } from '@/fo/ui/kit/checkbox/base';
import { UiKitInputBase } from '@/fo/ui/kit/input/base';
import { useForm } from '@/fo/ui/mod/form/base';
import { utilEventProductSubscribeModal } from '@/fo/util/event-product-subscribe-modal';

import { styles } from './FeatureProductFormSubscribe.styles';
import { Data, formAction } from './formAction';

export interface FeatureProductFormSubscribeProps {
  productId: string;
}

export function FeatureProductFormSubscribe({
  productId
}: FeatureProductFormSubscribeProps) {
  const t = useTranslations();
  const slots = styles();

  const { action, getFieldProps, pending, state } = useForm(formAction);

  const [formStep, setFormStep] = useState<'process' | 'success'>('process');

  const formData = state.data as Data;

  useEffect(() => {
    if (state.status === 'success' && !pending) {
      setFormStep('success');
    }
  }, [state, pending]);

  return (
    <div className={slots.base()}>
      {formStep === 'process' && (
        <>
          <div
            className={slots.title()}
            dangerouslySetInnerHTML={{
              __html: t('product.subscription.subtitle')
            }}
            suppressHydrationWarning
          />

          <form action={action}>
            <div className={slots.fields()}>
              <input
                type="hidden"
                name="productId"
                value={productId}
                readOnly
              />

              <UiKitInputBase
                label={t('form.label.email')}
                {...getFieldProps('email')}
                disabled={pending}
              />
            </div>

            <div className={slots.agreements()}>
              <UiKitCheckboxBase
                label={t('form.label.agreementMarketing')}
                {...getFieldProps('agreementMarketing')}
                disabled={pending}
              />

              <UiKitCheckboxBase
                label={t.rich('form.label.agreementPrivacy', {
                  link: (chunks) => (
                    <a
                      target="_blank"
                      rel="noreferrer"
                      className="font-bold"
                      href="/legal/politika-ooo-kompaniya-v-otnoshenii-obrabotki-personalnykh-dannykh"
                    >
                      {chunks}
                    </a>
                  )
                })}
                {...getFieldProps('agreementPrivacy')}
                disabled={pending}
              />
            </div>

            <UiKitButtonBase
              type="submit"
              className={slots.button()}
              loading={pending}
            >
              <span>{t('Find out about admission')}</span>
            </UiKitButtonBase>
          </form>
        </>
      )}

      {formStep === 'success' && (
        <>
          <div className={slots.title()}>
            {t.rich('product.subscription.successMsg', {
              email: () => <span className="font-bold">{formData.email}</span>
            })}
          </div>

          <UiKitButtonBase
            className={slots.button()}
            onClick={() => utilEventProductSubscribeModal.close()}
          >
            {t('Continue shopping')}
          </UiKitButtonBase>
        </>
      )}
    </div>
  );
}
